module.exports = __webpack_public_path__ + "static/media/forside.8519ed66.jpg";